import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

import TabPanel from './TabPanel.js'
import EditCard from '../EditCard.js'
import ContactUsPage from '../../Pages/ContactUs.js'
import ContactUsTable from '../Editables/ContactUsTable.js'

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
        display: 'flex',
        minHeight: '90vh',
    },
    tabs: {
        borderRight: `1px solid ${theme.palette.divider}`,
        width: '200px'
    }
}));

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  };
}

export default function ContactUs() {
    const classes = useStyles();
    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <div className={classes.root}>
            <Tabs
                orientation="vertical"
                indicatorColor="primary"
                variant="scrollable"
                value={value}
                onChange={handleChange}
                aria-label="Vertical tabs example"
                className={classes.tabs}
            >
                <Tab label="Preview" {...a11yProps(0)} />
                <Tab label="Address/Phone" {...a11yProps(1)} />
                <Tab label="Contact Us Form" {...a11yProps(2)} />
            </Tabs>
            <TabPanel value={value} index={0} preview>
                <ContactUsPage />
            </TabPanel>
            <TabPanel value={value} index={1} preview={false}>
                <EditCard title="ADDRESS & PHONE" textKey="cont_loc" heading subheading paragraph titleS="Address" titleP="Contact"/>
            </TabPanel>
            <TabPanel value={value} index={2} preview={false}>
                <div style={{padding: '30px'}}><ContactUsTable /></div>
            </TabPanel>
        </div>
    );
}
